module.exports = __webpack_public_path__ + "img/pink.f1e93438.png";